import { render, staticRenderFns } from "./playlist-widget.vue?vue&type=template&id=1e5e0ad2&"
import script from "./playlist-widget.vue?vue&type=script&lang=ts&"
export * from "./playlist-widget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports